import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserFormModule } from '../form/user-form.module';
import { AddUserRoutingModule } from './add-user-routing.module';
import { AddUserComponent } from './add-user.component';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    AddUserRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatInputModule,
    TextMaskModule,
    UserFormModule,
  ],
  declarations: [AddUserComponent],
  exports: [AddUserComponent],
  providers: [],
})
export class AddUserModule {}
